<template>
    <component :is="template">
        <v-sheet color="white">
            <section class="section section--1">
                <v-container>
                    <hunt-visual />
                    <hunt-reward class="mt-80px mt-md-160px mt-lg-190px"/>

                    <!-- 당첨슬라이드 -->
                    <hunt-winner-slide :logs="logs" :ranking="ranking" class="mt-80px mt-md-160px mt-lg-190px"/>

                    <!-- 보물찾기 이벤트 -->
                    <hunt-event class="mt-80px mt-md-160px mt-lg-190px"/>

                </v-container>
            </section>
            <section class="section section--2">
                <v-container>
                    <v-layout column align-center class="section--2__inner text-center">
                        <h2 class="tit mb-4 mb-md-6" data-aos="fade-up">
                            나누리 캐시 <br>
                            & 나누리 상품권 사용방법
                        </h2>
                        <h4 class="tit tit--xs grey-7d--text mb-6px" data-aos="fade-up" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 50 : 0">
                            대한문고 홈페이지에서 다양한 상품으로 교환 가능합니다.
                        </h4>
                        <p class="txt grey-7d--text font-weight-medium mb-3 mb-md-5" data-aos="fade-up" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 100 : 0">
                            <span class="font-size-12 d-inline-block pr-1">▶</span> 홈페이지 접속 → 로그인 → 나누리 충전 → 핀 번호 입력 → 교환소에서 사용
                        </p>
                        <v-btn large rounded color="primary" data-aos="fade-up" data-aos-duration="700" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 150 : 0" to="/gshop/brand">
                            <span class="inline-block mr-1">나누리 상품권 사용하기</span>
                            <right-arrow />
                        </v-btn>
                        <v-img src="/images/event/hunt/tube.png" max-width="152" :aspect-ratio="152 / 146" class="tube w-100" />
                    </v-layout>
                </v-container>
            </section>
            <section class="section section--3">
                <v-container>
                    <v-layout column align-center>
                        <h2 class="tit mb-4 mb-md-6 text-center" data-aos="fade-up">
                            꼭 알아두세요!
                        </h2>
                        <v-sheet max-width="640" data-aos="fade-up" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 50 : 0">
                            <ul class="dot-txts txt">
                                <li class="dot-txt">
                                    해당 이벤트는 한 ID당 1일 1회 참여 가능합니다.
                                </li>
                                <li class="dot-txt">
                                    부적절한 방법을 통해 이벤트 참여 시 이벤트 대상에서 제외됩니다. 
                                </li>
                                <li class="dot-txt">
                                    나누리 캐시는 당첨 즉시 발송되며, '마이페이지 → 캐시선물내역 → 받은내역' 에서 받기 후 사용하실 수 있습니다.
                                </li>
                                <li class="dot-txt">
                                    <strong>1, 2등  당첨 시 제세공과금(상품가격의 22%)이 부과</strong>되며, 처리를 위해 신분증 사본을 요청할 수 있습니다.또한 1, 2등 경품은 해당 이벤트 종료 후 일괄 배송됩니다. 
                                </li>
                                <li class="dot-txt">
                                    3,4등 경품은 참여 다음날 지급되며, 주말 참여 시 차주 월요일에 순차 지급됩니다.
                                </li>
                                <li class="dot-txt">
                                    나누리 상품권은 모바일 상품권으로 홈페이지에서 충전 후 사용 가능합니다.
                                </li>
                                <li class="dot-txt">
                                    당첨되신 경품은 즉시 사용가능하며 유효기간 이후에는 사용이 불가합니다.
                                </li>
                                <li class="dot-txt">
                                    해당 이벤트는 경품 소진 시 세부 일정 변경 및 조기 종료될 수 있습니다.
                                </li>
                                <li class="dot-txt">
                                    유의 사항 미숙지 및 회원정보 오류로 인한 경품 미수신 시 재발송이 불가합니다.
                                </li>
                            </ul>
                        </v-sheet>
                        <v-img src="/images/logo.png" max-width="100%" :aspect-ratio="380 / 36" contain class="mt-80px mt-md-120px mt-lg-160px w-220px w-md-380px" />
                    </v-layout>
                </v-container>
            </section>
        </v-sheet>
    </component>
</template>

<script>
import HuntVisual from "@/components/client/event/hunt/hunt-visual.vue";
import HuntReward from "@/components/client/event/hunt/hunt-reward.vue";
import HuntWinnerSlide from "@/components/client/event/hunt/hunt-winner-slide.vue";
import HuntEvent from "@/components/client/event/hunt/hunt-event.vue";
import RightArrow from "@/components/client/event/hunt/right-arrow.vue";
import api from '@/api';

export default {
    components: {
        HuntVisual,
        HuntReward,
        HuntWinnerSlide,
        HuntEvent,
        RightArrow,
    },
    data() {
        return {
            logs: null,
            ranking: null
        };
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.main}`);
        },
    },
    mounted() {
        this.init();
    },
	methods : {
		async init() {
            let { logs } = await api.v1.hunt.logs.gets({ // 랭킹 5가 아닌거 모두
                params: { ranking: false }
            });
            this.logs = logs;

            let { logs: ranking } = await api.v1.hunt.logs.gets({ // 랭킹 5인거 하루 날짜
                params: { ranking: true }
            });
            this.logs = logs;
            this.ranking = ranking;
            
            let mobileWidth = 768;
            let offsetY = 300;
            if (window.innerWidth < mobileWidth) {
                offsetY = 180;
            }
            // console.log(window.innerWidth)
            setTimeout(() => {
                AOS.init({
                    once: true,
                    offset: offsetY,
                    duration: 500,
                    throttleDelay : 100,
                    easing : 'ease-out',
                    anchorPlacement : 'top-center',
                });
            }, 100);
		}
	},
};
</script>

<style lang="scss" scoped>
@import "@/styles/_event.scss";

.section{
    &--1{
        padding: 50px 0;
        background-image: url(/images/event/hunt/section1-bg-mo.jpg);
        background-repeat: no-repeat;
        background-position: center top;
        background-size: cover;
    }
    &--2{
        background-image: url(/images/event/hunt/section2-bg-mo.jpg);
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        &__inner{
            position: relative;
            padding: 50px 0;
            .tube{
                position: absolute;
                bottom: 70px;
                right: 62px;
                transform: translate(100%, 100%);
                display: none;
            }
        }
    }
    &--3{
        padding: 50px 0 20px;
        background-image: url(/images/event/hunt/section3-bg-mo.jpg);
        background-repeat: no-repeat;
        background-position: center bottom;
        background-size: 100% auto;
        background-color: #fff;
    }
}

@media (min-width:576px){
}
@media (min-width:768px){
    .section{
        &--1{
            padding: 46px 0 140px;
            background-image: url(/images/event/hunt/section1-bg.jpg)
        }
        &--2{
            background-image: url(/images/event/hunt/section2-bg.jpg)
        }
        &--3{
            padding: 70px 0 30px;
            background-image: url(/images/event/hunt/section3-bg.jpg);
        }
    }
}
@media (min-width:1024px){
}
@media (min-width:1200px){
    .section{
        &--2{
            &__inner{
                .tube{
                    display: block;
                }
            }
        }
    }
}

</style>
